// extracted by mini-css-extract-plugin
module.exports = {"bookTrialClassModal":"BookTrialClassModal_bookTrialClassModal__fIVE_"};